import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { CreateGroupData, TDataToken, TQueries, UpdateGroupPolicyArgs } from "./type";


export const createGroup = (
  data: TDataToken,
  payload: CreateGroupData
) => {
  return $api
    .post("/admin/groups/create-group", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useCreateNewGroup = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateGroupData>
) => {
  return useMutation({
    mutationFn: (payload:CreateGroupData) =>
      createGroup(data, payload),
    ...config
  });
};


export const getGroupDetails = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .get("/admin/groups/details", { token: data.accessToken, params: { ...payload } })
        .then((response) => {
            return response;
        });
};

export const useGetGroupDetails = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["group-details", queries],
        queryFn: () => getGroupDetails(data, queries),
        ...config as UseQueryOptions<any>
    });
};


export const updateGroup = (
  data: TDataToken,
  payload: CreateGroupData
) => {
  return $api
    .put("/admin/groups/update-group", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateGroup = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, CreateGroupData>
) => {
  return useMutation({
    mutationFn: (payload:CreateGroupData) =>
      updateGroup(data, payload),
    ...config
  });
};


export const updateGroupPolicy = (
  data: TDataToken,
  {groupID, payload}: UpdateGroupPolicyArgs
) => {
  return $api
    .put(`/admin/groups/update-view-policy?groupID=${groupID}`, { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useUpdateGroupPolicy = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, UpdateGroupPolicyArgs>
) => {
  return useMutation({
    mutationFn: (payload) =>
      updateGroupPolicy(data, payload),
    ...config
  });
};


export const deleteGroup = (data: TDataToken, payload: TQueries) => {
  return $api
    .delete(`/admin/groups/${payload}/delete`, {token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useDeleteGroup = (data: TDataToken, config?: UseMutationOptions<any, unknown, TQueries>) => {
  return useMutation({
    mutationFn: (payload: TQueries) => deleteGroup(data, payload),
    ...config
  });
};